export const DOWNLOAD_CSV_IS_SAVED = 'DOWNLOAD_CSV_IS_SAVED'